import { CommonModule } from '@angular/common';
import { CascadeSelectComponent } from './cascade-select.component';
import { NgModule } from '@angular/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { PipeModule } from 'clink-ui-x/pipe';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [CascadeSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzCheckboxModule,
        NzGridModule,
        PipeModule,
    ],
    exports: [CascadeSelectComponent],
})
export class CascadeSelectModule {}
